import { useGetList } from "ra-core";
import { useMemo } from "react";
import type { Product } from "./types";

const FIELDS = ["clase", "marca", "origen", "color"] as const;

// No hay tabla de referencia para estos valores (son texto libre en la
// planilla original) — traemos todo el catálogo una sola vez (855 filas,
// liviano) y derivamos los valores distintos en el cliente para armar los
// dropdowns de filtro.
export const useProductFilterChoices = () => {
  const { data, isPending } = useGetList<Product>("products", {
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "producto", order: "ASC" },
  });

  return useMemo(() => {
    const result = {} as Record<(typeof FIELDS)[number], { id: string; name: string }[]>;
    for (const field of FIELDS) {
      const values = new Set<string>();
      (data ?? []).forEach((record) => {
        const value = record[field];
        if (value) values.add(value as string);
      });
      result[field] = Array.from(values)
        .sort((a, b) => a.localeCompare(b))
        .map((value) => ({ id: value, name: value }));
    }
    return { choices: result, isPending };
  }, [data, isPending]);
};
